var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _vm.modalExportData
        ? _c(
            "EmptyCardModal",
            {
              ref: "exportXlsModal",
              attrs: {
                modalData: _vm.modalExportData,
                onModalClose: () => (_vm.modalExportData = null),
                onModalAccept: () => _vm.exportXLS(true),
              },
            },
            [
              _vm._t("default", function () {
                return [
                  _c(
                    "div",
                    [
                      _c("ExcelExportOptions", {
                        ref: "exportExcelOptions",
                        attrs: {
                          extraOptions: {
                            groupPrices: true,
                            invoiceNum: true,
                            incomeByFact: true,
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "card" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c(
                "div",
                { staticClass: "text-right" },
                [
                  _c("LoadingButton", {
                    attrs: {
                      title: "экспортировать в XLS",
                      loading: _vm.btnLoading,
                      type: "button",
                      color: _vm.$constants.PRIMARY_COLOR,
                      onClick: () => _vm.exportXLS(),
                      className: "btn btn-outline-info",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-info btn-sm",
                      on: {
                        click: function ($event) {
                          return _vm.getRecords(1)
                        },
                      },
                    },
                    [_vm._v("Обновить")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("pulse-loader", {
                staticClass: "text-center mt-3",
                attrs: {
                  loading: _vm.loading,
                  color: _vm.$constants.LOADING_COLOR,
                },
              }),
              _vm._v(" "),
              !_vm.loading
                ? [
                    _c("div", [
                      _c(
                        "table",
                        { staticClass: "table table-hover table-sm mt-1" },
                        [
                          _vm._m(0),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.records, function (record, i) {
                              return _c(
                                "tr",
                                {
                                  key: record.id,
                                  class: {
                                    mark: _vm.selectedOrders[record.id],
                                  },
                                },
                                [
                                  _c("td", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.selectedOrders[record.id],
                                          expression:
                                            "selectedOrders[record.id]",
                                        },
                                      ],
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.selectedOrders[record.id]
                                        )
                                          ? _vm._i(
                                              _vm.selectedOrders[record.id],
                                              null
                                            ) > -1
                                          : _vm.selectedOrders[record.id],
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a =
                                              _vm.selectedOrders[record.id],
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.selectedOrders,
                                                  record.id,
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.selectedOrders,
                                                  record.id,
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.selectedOrders,
                                              record.id,
                                              $$c
                                            )
                                          }
                                        },
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        i +
                                          1 +
                                          (_vm.paginator.current_page - 1) *
                                            _vm.paginator.per_page
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(record.id))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(record.supplier_title)),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("strong", [
                                      _vm._v(_vm._s(record.details.length)),
                                    ]),
                                    _vm._v(
                                      " на сумму\n                  " +
                                        _vm._s(
                                          _vm.$AllCurrencies[record.currency_id]
                                            .currency
                                        ) +
                                        "\n                  "
                                    ),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          record.totalDrugsSum.toLocaleString(
                                            "ru-RU"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        record.discount
                                          ? record.discount +
                                              (+record.discount_type === 1
                                                ? "%"
                                                : "")
                                          : null
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("span", { staticClass: "mr-2" }, [
                                      _vm._v(
                                        _vm._s(
                                          record.extra_settings
                                            ?.expenses_by_price
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "mr-2" }, [
                                      _vm._v(
                                        _vm._s(
                                          record.extra_settings?.expenses_by_qty
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$AllCurrencies[record.currency_id]
                                          .currency
                                      ) + " "
                                    ),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          record.totalDrugsSumDiscounted.toLocaleString(
                                            "ru-RU"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(record.comment))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-xs btn-info newWindowBtn",
                                        on: {
                                          click: function ($event) {
                                            return _vm.showInvoice(record.id)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "icon-fa icon-fa-eye",
                                        }),
                                      ]
                                    ),
                                  ]),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "text-right" },
                      [
                        _vm.paginator
                          ? _c("paginate", {
                              ref: "Pagination",
                              attrs: {
                                "page-count": _vm.paginator.last_page,
                                "page-range": 11,
                                "margin-pages": 2,
                                "click-handler": _vm.getRecords,
                                "prev-text": "&laquo",
                                "next-text": "&raquo",
                                "container-class": "pagination",
                                "prev-class": "page-item",
                                "prev-link-class": "page-link",
                                "page-class": "page-item",
                                "page-link-class": "page-link",
                                "next-class": "page-item",
                                "next-link-class": "page-link",
                                "active-class": "active green_btn",
                              },
                              model: {
                                value: _vm.paginator.current_page,
                                callback: function ($$v) {
                                  _vm.$set(_vm.paginator, "current_page", $$v)
                                },
                                expression: "paginator.current_page",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Поставщик")]),
        _vm._v(" "),
        _c("th", [_vm._v("Препараты")]),
        _vm._v(" "),
        _c("th", [_vm._v("Скидка")]),
        _vm._v(" "),
        _c("th", [_vm._v("Расходы")]),
        _vm._v(" "),
        _c("th", [_vm._v("Всего")]),
        _vm._v(" "),
        _c("th", [_vm._v("Комментарий")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }